/**
 * Default provider discovery: Phantom-first, then any Wallet-Standard
 * `window.solana`. Kept tiny + synchronous (no heavy imports) so it works inside
 * a user gesture and can be eagerly exported from the SDK entry.
 */
export function defaultInjectedProvider() {
    var _a;
    if (typeof window === 'undefined')
        return null;
    const w = window;
    const phantom = (_a = w === null || w === void 0 ? void 0 : w.phantom) === null || _a === void 0 ? void 0 : _a.solana;
    if (phantom && typeof phantom.signMessage === 'function')
        return phantom;
    const generic = w === null || w === void 0 ? void 0 : w.solana;
    if (generic && typeof generic.signMessage === 'function')
        return generic;
    return null;
}
